/**
 * @module Button
 */

export enum Action {
  CLICK = 'CLICK',
  UPDATE = 'UPDATE',
}

export enum ActionType {
  CLICK = 'APP::BUTTON::CLICK',
  UPDATE = 'APP::BUTTON::UPDATE',
}

export interface Options {
  label: string;
  primary?: boolean;
  disabled?: boolean;
}

export interface Payload extends Options {
  readonly id: string;
}

export interface ClickPayload {
  readonly id: string;
  payload?: any;
}



// WEBPACK FOOTER //
// ./src/actions/Button/types.ts